// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SeoBlocks_wrapper__TGsFH","seoWrapper":"SeoBlocks_seoWrapper__Mqung","seoHeading":"SeoBlocks_seoHeading__e0DYB"};